import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSettings02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m9.742 21.554-.652-1.446a2.682 2.682 0 0 0-1.122-1.228 2.75 2.75 0 0 0-1.64-.344l-1.597.168a2.504 2.504 0 0 1-1.381-.252 2.457 2.457 0 0 1-1.019-.952 2.404 2.404 0 0 1 .142-2.649l.945-1.28a2.645 2.645 0 0 0 0-3.143l-.945-1.28A2.41 2.41 0 0 1 2.33 6.5a2.455 2.455 0 0 1 1.019-.952 2.502 2.502 0 0 1 1.38-.252l1.602.168a2.75 2.75 0 0 0 1.641-.344A2.682 2.682 0 0 0 9.09 3.892l.652-1.446c.194-.43.51-.796.911-1.053a2.497 2.497 0 0 1 2.694 0c.4.257.717.622.91 1.053l.658 1.446c.231.515.622.945 1.117 1.228a2.75 2.75 0 0 0 1.64.344l1.598-.168c.475-.05.954.038 1.38.252.426.213.78.544 1.019.952a2.403 2.403 0 0 1-.142 2.649l-.945 1.28A2.645 2.645 0 0 0 20.063 12a2.645 2.645 0 0 0 .514 1.578l.945 1.28a2.41 2.41 0 0 1 .142 2.648 2.454 2.454 0 0 1-1.019.953 2.502 2.502 0 0 1-1.38.251l-1.597-.167a2.75 2.75 0 0 0-1.641.343c-.494.281-.885.71-1.117 1.222l-.652 1.446c-.194.43-.51.796-.911 1.053a2.497 2.497 0 0 1-2.694 0 2.444 2.444 0 0 1-.91-1.053ZM15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
      clipRule="evenodd"
    />
  </svg>
);
SvgSettings02.displayName = 'Settings02';
export default SvgSettings02;
